import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  "image-rendering": "optimizeQuality",
  "shape-rendering": "geometricPrecision",
  "text-rendering": "geometricPrecision",
  viewBox: "0 0 203.55 141.6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "fill-rule": "nonzero" }, [
      _createElementVNode("path", {
        fill: "#006AA7",
        d: "M11.19 0h181.17c6.15 0 11.19 5.03 11.19 11.19v119.22c0 6.16-5.04 11.19-11.19 11.19H11.19C5.03 141.6 0 136.57 0 130.41V11.19C0 5.03 5.03 0 11.19 0"
      }),
      _createElementVNode("path", {
        fill: "#FECC00",
        d: "M0 56.51h58.9V0h28.58v56.51h116.07v28.58H87.48v56.51H58.9V85.09H0z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "flag-swe"}) } }